var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.547 24h-6.694c-.656 0-1.065.681-.738 1.227l3.347 5.564c.328.545 1.148.545 1.476 0l3.347-5.564c.327-.546-.082-1.227-.738-1.227M18 18.225c0 .979-.797 1.775-1.775 1.775h-4.45A1.777 1.777 0 0 1 10 18.225v-4.45c0-.978.797-1.775 1.775-1.775h4.45c.978 0 1.775.797 1.775 1.776v4.449zM11.041 9A4.041 4.041 0 0 0 7 13.041v5.918A4.04 4.04 0 0 0 11.041 23h5.918A4.041 4.041 0 0 0 21 18.959v-5.918A4.041 4.041 0 0 0 16.959 9h-5.918z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBlack);
export default __webpack_public_path__ + "static/media/markerBlack.9a8986d44f904ee9187ff3ca83299eae.svg";
export { ForwardRef as ReactComponent };